<template>
  <div>
    <!-- <SearchArea :searchTerm="searchText" @update-search="updateSearchText" /> -->
    <!-- <ListItem /> -->
    <v-flex xs12>
      <v-img dark height="120" src="img/banner.jpg">
        <div align="center" class="font-weight-black display-1 mt-9">
          {{ $t("mediaMessage") }}
        </div>
      </v-img>
    </v-flex>
    <MediaSection
      :totalPages="totalPages"
      :currentPage.sync="currentPage"
      :searchTerm="searchTerm"
      :selectedItemTypes="selectedItemTypes"
      :itemObjects="itemObjects"
      :showSidebar="showSidebar"
      :sidebarData="filtersWithCounts"
      @formSubmitted="fetchSearchResults"
      @update:searchTerm="updateSearchText($event)"
      @update:selectedSidebarItems="handleSelectedSidebarItems"
    >
      <template #listItems>
        <ShowMedia :itemObjects="itemObjects" :currentTab.sync="currentTab" />
      </template>
    </MediaSection>
  </div>
</template>
<style></style>
<script>
import apiCall from "@/utils/api";
import SearchArea from "@/components/search/Base/SearchArea.vue";
// import ListItem from "@/components/search/ListItem.vue";
import MediaSection from "@/components/search/media/MediaSection.vue";
import ShowMedia from "@/components/search/media/ShowMedia.vue";

export default {
  components: {
    // ListItem,
    MediaSection,
    SearchArea,
    ShowMedia,
  },
  data: () => ({
    searchText: "",
    totalPages: null,
    currentPage: 1,
    searchTerm: "",
    filteredSearchItems: [],
    rng: null,
    currentTab: "all",
    showSidebar: false,
    isFilterActive: false,
    itemObjects: [],
    itemsPerPage: 10,
    selectedItemTypes: [],
    selectedSidebarItems: [],
    isLoading: false,
  }),
  created() {
    if (this.$route.query && this.$route.query.searchTerm) {
      this.searchTerm = this.$route.query.searchTerm;
      //this.setSearchItems();
    }
    this.fetchSearchResults();
  },
  //   beforeRouteUpdate(to) {
  //     console.log(to);
  //   },
  computed: {
    filtersWithCounts() {
      let groupedCounts = null;
      if (this.isLoading) {
        return null;
      } else {
        if (this.isFilterActive) {
          groupedCounts = this.itemObjects.reduce((acc, item) => {
            const typeName = item.submission_type.name;
            acc[typeName] = (acc[typeName] || 0) + 1;
            return acc;
          }, {});
        } else {
          groupedCounts = this.filteredSearchItems.reduce((acc, item) => {
            const typeName = item.submission_type.name;
            acc[typeName] = (acc[typeName] || 0) + 1;
            return acc;
          }, {});
        }

        const result = Object.entries(groupedCounts).map(([name, count]) => ({
          name,
          count,
        }));
        return result;
      }
    },
    paginatedSearchItems() {
      if (this.filteredSearchItems && this.filteredSearchItems.length > 0) {
        const firstItemIndex = (this.currentPage - 1) * this.itemsPerPage;
        let lastItemIndex = firstItemIndex + (this.itemsPerPage - 1);
        const finalListIndex = this.filteredSearchItems.length - 1;

        if (lastItemIndex > finalListIndex) {
          lastItemIndex = finalListIndex;
        }

        if (firstItemIndex > finalListIndex) {
          return null;
        }

        return this.filteredSearchItems.slice(
          firstItemIndex,
          lastItemIndex + 1
        );
      }

      return null;
    },
    categoryCounts() {
      return this.itemObjects.map((category) => {
        return {
          title: category.name,
          count: category.items ? category.items.length : 0,
        };
      });
    },
  },
  watch: {
    currentTab(newVal) {
      this.fetchSearchResults(newVal);
    },
    $route: {
      handler(newRoute) {
        const tab = newRoute.query?.tab;
        if (!!tab) {
          this.currentTab = tab;
        } else {
          this.currentTab = "all";
        }
      },
      immediate: true,
    },
  },
  methods: {
    updateSearchText(event) {
      this.searchTerm = event;
    },
    navigateToDestination(item) {
      this.$router.push({
        // name:'viewMore',
        // params:{uuid:itemuuid, itemType:itemType}
      });
    },
    setSearchItems() {
      if (this.itemObjects) {
        let filteredSearchItems = [];

        let atLeastOneFilterActive = false;

        this.itemObjects.forEach((itemObject) => {
          if (
            itemObject.filterObj &&
            this.filterActive(itemObject.filterObj.filters)
          ) {
            atLeastOneFilterActive = true;
          }
        });

        this.itemObjects.forEach((itemObject) => {
          const items = itemObject.items;

          if (items && items.length > 0) {
            /*items.forEach((item) => {
			  item.type = itemObject.type;
			  item.color = itemObject.color;
			});*/

            let filteredItems = [];
            if (this.searchTerm !== null && this.searchTerm !== "") {
              if (items && items.length > 0) {
                filteredItems = this.getItemsMatchingSearchTerm(
                  this.searchTerm,
                  items
                );
              }
            } else {
              filteredItems = items;
            }
            /*
			if (atLeastOneFilterActive) {
			  filteredItems = itemObject.getItemsMatchingFilters(
				filteredItems,
				itemObject.filterObj.filters
			  );
			}*/

            filteredSearchItems = [...filteredSearchItems, ...filteredItems];
          }
        });

        this.currentPage = 1;

        this.totalPages = Math.ceil(
          filteredSearchItems.length / this.itemsPerPage
        );

        this.filteredSearchItems = filteredSearchItems;
        /*
		this.filteredSearchItems = shuffle(
		  filteredSearchItems,
		  this.rng ? this.rng() : null
		);*/
      }

      return null;
    },
    getItemsMatchingSearchTerm(searchTerm, items) {
      console.log(searchTerm);
      return items.filter((item) => {
        return (
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.tags.some((tag) =>
            tag.toLowerCase().includes(searchTerm.toLowerCase())
          )
        );
      });
    },

    findFilterItem(filterItem, value) {
      return filterItem.items.find((item) => item.value === value);
    },

    removeFilterValue(filterItem, value) {
      const index = filterItem.value.indexOf(value);
      if (index || index === 0) {
        filterItem.value.splice(index, 1);
      }
    },

    filterActive(filters) {
      const activeFilterItems = filters.filter((item) =>
        // arrayNotEmpty(item.value)
        console.log("test")
      );
      return activeFilterItems.length > 0;
    },

    fetchSearchResults(option) {
      this.filteredSearchItems = null;
      this.isLoading = true;
      apiCall({
        url:
          "/api/search-submission?search-type=mediaSearch&search-term=" +
          this.searchTerm +
          "&submission-type=" +
          null +
          "&option=" +
          option,

        data: null,
        method: "GET",
      })
        .then((resp) => {
          this.itemObjects = resp.data;
          this.filteredSearchItems = this.itemObjects;

          this.currentPage = 1;
          this.totalPages = Math.ceil(
            this.filteredSearchItems.length / this.itemsPerPage
          );
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isLoading = false; // Reset loading state
        });
    },
    handleSelectedSidebarItems(selectedItems) {
      this.selectedSidebarItems = [...selectedItems];

      if (
        !this.selectedSidebarItems ||
        this.selectedSidebarItems.length === 0
      ) {
        this.filteredSearchItems = this.itemObjects;
        this.isFilterActive = false;
        this.currentPage = 1;
        this.totalPages = Math.ceil(
          this.filteredSearchItems.length / this.itemsPerPage
        );
        return;
      }

      const updatedFilteredItems = this.itemObjects.filter((item) => {
        return this.selectedSidebarItems.some((selectedItem) => {
          return item.submission_type.name.includes(selectedItem);
        });
      });

      this.filteredSearchItems = updatedFilteredItems;
      this.isFilterActive = true;
      this.currentPage = 1;
      this.totalPages = Math.ceil(
        this.filteredSearchItems.length / this.itemsPerPage
      );
    },
  },
};
</script>
